import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, LOGO_URL } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-md bg-[#141417] border border-[#27272A] px-4 py-3.5 text-white placeholder-zinc-500 outline-none focus:border-[#D4AF37]";

  if (!token)
    return (
      <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4 text-center">
        <div>
          <p className="text-white font-display text-2xl uppercase">Invalid Link</p>
          <Link to="/admin/forgot-password" className="text-[#D4AF37] text-sm mt-3 inline-block">Request a new reset link</Link>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="ABE" className="h-12 mx-auto logo-invert" />
          <p className="font-oswald text-xs tracking-widest text-zinc-500 mt-3">SET A NEW PASSWORD</p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="reset-password" type="password" required placeholder="New password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
          <input data-testid="reset-confirm" type="password" required placeholder="Confirm new password" className={field} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <button data-testid="reset-submit" disabled={loading} className="btn-gold w-full rounded-md py-3.5 font-oswald tracking-widest disabled:opacity-60">
            {loading ? "UPDATING…" : "UPDATE PASSWORD"}
          </button>
        </form>
      </div>
    </div>
  );
}
